export default {"src":"/_next/static/media/high-contrast.688ff4d6.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};